document.addEventListener('DOMContentLoaded', function() {
    console.log('width', $( window ).width());
    if($( window ).width() < 992){
        var links = $('.navbar-nav .dropdown-toggle');
        function expandMenu(e) {
            var display = $(this).find('.dropdown-menu').css("display");
            if (display == "block") {
                $(this).find('.dropdown-menu').css("display", "none");
            } else {
                $(this).find('.dropdown-menu').css("display", "block");
            }
        }

        $('.navbar-nav .dropdown').on('click', expandMenu);
    }
}, false);
